module.exports = __webpack_public_path__ + "static/adminphfree-eb3f89f697df3f3d81ed74dad2142f7f.png";